<button sui-icon-button [disabled]="disabled">
  <sui-icon
    [name]="direction === 'left' ? '화살표_왼쪽' : '화살표_오른쪽'"
  ></sui-icon>
</button>
